import {
  BasePageModel,
  basePageToLocal,
  FramelyAction,
  actionToLocal,
  actionToServer
} from './index';

import { SourceType } from '@config/index';

export interface PostFillAction extends BasePageModel {
  condition: string;
  conditionComment?: string;
  actions: FramelyAction[];
  masterSelf?: PostFillAction;
}

export function postFillActionToLocal(data: any): PostFillAction {

  return {
    ...basePageToLocal(data),
    condition: data.condition,
    conditionComment: data.condition_comment,
    actions: data.actions && data.actions.map(actionToLocal),
    masterSelf: data.master_self && postFillActionToLocal(data.master_self)
  };
}

export function postFillActionToServer(data: PostFillAction) {

  const res: any = {
    id: data.id,
    owner_id: data.ownerId,
    owner_type: data.ownerType,
    frame_id: data.frameId,
    to_be_deleted: data.toBeDeleted,
    condition: data.condition,
    condition_comment: data.conditionComment,
    actions: data.actions && data.actions.map(actionToServer)
  };

  if (!res.id || !res.id.length) {
    delete res.id;
  }

  return res;
}
